import * as Yup from 'yup'

export default Yup.object().shape({
  email: Yup.string().email().trim().required('Email is required'),
})
